import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
export const pageSearch = {
  'wantCode': {
    title: '发货单号',
    type: 'input'
  },
  'warehouse': {
    title: '发货仓库',
    type: 'select',
    equation: all,
    dictionary: 'Warehouse'
  },
  'startday': {
    title: '对账周期起',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },
  'startDate': {
    title: '发货单日期起',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },
  'endDate': {
    title: '发货单日期止',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },
  'customerCode': {
    title: '客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  'productCode': {
    title: '产品',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品选择'
    }
  },
  'remark': {
    title: '备注反馈情况',
    type: 'select',
    equation: all,
    dictionary: 'remark'
  },
  'settlement': {
    title: '是否已结算',
    type: 'whether',
    equation: all
  },
  'checkOut': {
    title: '是否已对账',
    type: 'whether',
    equation: all
  }
}

export default {
  'wantCode': { title: '对账单号' },
  'customerName': { title: '客户名称' },
  'productDesc': { title: '产品' },
  'createdDate': { title: '发货申请日期' },
  'wantQuantity': { title: '申请发货量(件)' },
  'reachedTime': { title: '应到货时间' },
  'wantQuantityDetail': { title: '瓶' },
  'receiveAddress': { title: '收货地址' },
  'sendTime': { title: '接收时间' },
  'actDeliveryQty': { title: '接收量' },
  'warehouse': { title: '发货仓库' },
  'wantQuantity0': { title: '实际发货量' },
  'assignCarTime': { title: '派车时间' },
  'shipTime': { title: '发货时间' },
  'signDate': { title: '客户签收时间' },
  'action1': { title: '运单签收附件' },
  'aciton2': { title: '客户签收附件' },
  'remark': { title: '备注' },
  'checkOut': { title: '是否对账' },
  'settlement': { title: 'settlement' }
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/deliveryOrderSearch.js